import { createFileRoute } from "@tanstack/react-router";
import Properties from "@/pages/Properties";

export const Route = createFileRoute("/properties")({
  head: () => {
    const title = "Properties for Sale and Rent in Mumbai | MNRE";
    const description = "Browse verified residential and commercial properties across Mumbai. Filter by location, budget, BHK & more. Apartments, penthouses, villas & offices.";
    const canonicalUrl = "https://mnre.in/properties";
    const ogImage = "https://mnre.in/blog-covers/mumbai-sealink-skyline.jpg";

    const breadcrumbJsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://mnre.in/" },
        { "@type": "ListItem", position: 2, name: "Properties", item: canonicalUrl },
      ],
    };

    const agentJsonLd = {
      "@context": "https://schema.org",
      "@type": "RealEstateAgent",
      name: "Mohnish Nagpal Real Estate",
      url: canonicalUrl,
      image: ogImage,
      telephone: "+917021011304",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Ajanta Building, 3rd Road",
        addressLocality: "Khar West",
        addressRegion: "Mumbai, Maharashtra",
        postalCode: "400052",
        addressCountry: "IN",
      },
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:image", content: ogImage },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify([agentJsonLd, breadcrumbJsonLd]),
        },
      ],
    };
  },
  component: Properties,
});
